// import wasmUrl from "@automerge/automerge/automerge.wasm?url";
// import * as Automerge from "@automerge/automerge/slim";
import * as Automerge from "@automerge/automerge/slim";
import * as AutomergeRepo from "@automerge/automerge-repo/slim";
import { IndexedDBStorageAdapter } from "@automerge/automerge-repo-storage-indexeddb"
import { WebSocketClientAdapter } from "@automerge/automerge-repo-network-websocket"
import Alpine from 'alpinejs'


// NOTE: Main function is needed because top-level await is not supported by Parcel
async function main() {
    console.log('Initialize wasm');
    // await Automerge.initializeWasm("https://esm.sh/@automerge/automerge@3.2.4/dist/automerge.wasm");
    await Automerge.initializeWasm("/automerge_wasm_bg.4f23e050.wasm")

    console.log('Create Repo');
    const repo = new AutomergeRepo.Repo({
        network: [new WebSocketClientAdapter("wss://sync.automerge.org")],
        storage: new IndexedDBStorageAdapter(),
    })

    /* Check the location hash for a Automerge document URL */
    console.log('Check location hash for Automerge document URL');
    const rootDocUrl = `${document.location.hash.substring(1)}`
    let handle
    if (AutomergeRepo.isValidAutomergeUrl(rootDocUrl)) {
        console.log('Automerge document found')
        handle = await repo.find(rootDocUrl)
    } else {
        console.log('Create new document')
        handle = repo.create({ count: 0 })
        document.location.hash = handle.url;
    }

    console.log('Initialize Alpine data')
    Alpine.data('counter', () => {
        return {
            count: 0,
            doc: handle.doc(),

            async init() {
                this.count = this.doc.count;
                this.$watch('count', (value) => {
                    handle.change((d) => (d.count = value));
                });
            }
        };
    });

    window.Alpine = Alpine
    Alpine.start();
}

main()
